import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { usePortalAuth } from "@/hooks/usePortalAuth";
import { useTenant } from "@/contexts/TenantContext";
import { OAUTH_RETURN_KEY } from "@/pages/OAuthConsentPage";

export const RootRedirect = () => {
  const { user, userRole, loading } = useAuth();
  const { portalUser, loading: portalLoading } = usePortalAuth();
  const { isGreenvisionCharging } = useTenant();

  console.log('[RootRedirect] State:', { 
    user: !!user, 
    userRole, 
    loading, 
    portalLoading,
    isGreenvisionCharging 
  });

  if (loading || portalLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Back to a pending OAuth consent (external AI client) after signing in.
  const oauthReturn = user ? sessionStorage.getItem(OAUTH_RETURN_KEY) : null;
  if (oauthReturn) {
    sessionStorage.removeItem(OAUTH_RETURN_KEY);
    if (oauthReturn.startsWith("/oauth/consent?")) return <Navigate to={oauthReturn} replace />;
  }

  // Charging users → charging portal
  if (user && userRole === 'charging_user' && isGreenvisionCharging) {
    console.log('[RootRedirect] Redirecting to /charging');
    return <Navigate to="/charging" replace />;
  }

  // CRM users with role
  if (user && userRole && ['admin', 'super_admin', 'crm_user'].includes(userRole)) {
    return <Navigate to="/crm" replace />;
  }

  // Portal users
  if (portalUser) {
    const path = portalUser.role === 'inspector' ? '/inspector' : '/client';
    return <Navigate to={path} replace />;
  }

  // Not logged in - show auth
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Fallback: authenticated but no role yet
  return <Navigate to="/auth" replace />;
};
